import * as ACTIONS from "../actions/types"
import _ from "lodash"

export const initialState = {
  phoneID: [],
  planID: null,
  extras: [],
  benefits: [],
  entertainment: {},
  allPlansButtonClicked: false,
  builtPlan: null
}

// A reducer to handle putting things into the basket
// Ie, what people have selected

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTIONS.RESET_BASKET: {
      return {
        ...initialState,
        phoneID: state.phoneID
      }
    }

    case ACTIONS.SELECT_DEVICE: {
      return { ...state, phoneID: payload }
    }

    case ACTIONS.SELECT_PLAN: {
      return { ...state, planID: payload }
    }

    case ACTIONS.ADD_EXTRA: {
      // check to see if the extra is Halo 3 - if so, then remove Complete_wifi and hybrid_hub
      if (payload === "HALO_PREMIUM") {
        // we want to filter out complete_wifi and hybrid_hub
        let newExtras = state.extras.filter(
          extraID => extraID !== "COMPLETE_WIFI" && extraID !== "HYBRID_HUB"
        )
        // then add Halo 3
        newExtras = _.includes(newExtras, payload)
          ? newExtras
          : [...newExtras, payload]
        // and return that hot mess
        return { ...state, extras: newExtras }
      } else if (payload === "COMPLETE_WIFI" || payload === "HYBRID_HUB") {
        // we want to filter out Halo 3
        let newExtras = state.extras.filter(
          extraID => extraID !== "HALO_PREMIUM"
        )
        // then add this extra
        newExtras = [...newExtras, payload]
        // and return that hot mess
        return { ...state, extras: newExtras }
      }

      const newExtras = _.includes(state.extras, payload)
        ? state.extras
        : [...state.extras, payload]
      return { ...state, extras: newExtras }
    }

    case ACTIONS.REMOVE_EXTRA: {
      const removedExtras = _.includes(state.extras, payload)
        ? _.remove(state.extras, extra => extra !== payload)
        : state.extras
      return { ...state, extras: removedExtras }
    }

    case ACTIONS.ADD_ENTERTAINMENT: {
      return {
        ...state,
        entertainment: {
          ...state.entertainment,
          [payload.planID]: payload.entertainmentCost
        }
      }
    }

    case ACTIONS.BUILT_PLAN: {
      return {
        ...state,
        builtPlan: {
          ...payload
        }
      }
    }

    case ACTIONS.FLAG_GOTO_FIRST_PAGE: {
      return {
        ...initialState,
        phoneID: state.phoneID
      }
    }

    case ACTIONS.ADD_BENEFIT: {
      const newBenefits = _.includes(state.benefits, payload)
        ? state.benefits
        : [...state.benefits, payload]
      return { ...state, benefits: newBenefits }
    }

    case ACTIONS.REMOVE_BENEFIT: {
      const removedBenefits = _.includes(state.benefits, payload)
        ? _.remove(state.benefits, benefit => benefit !== payload)
        : state.extras
      return { ...state, benefits: removedBenefits }
    }

    case ACTIONS.ALL_PLANS_BUTTON_CLICKED: {
      return { ...state, allPlansButtonClicked: payload }
    }

    default:
      return state
  }
}
